import React from 'react';
import { string } from 'prop-types';
import { Link } from 'react-router-dom';

import Button from './Button';

import { colors } from '../../constants/styleConstants';

const StyledLink = ({ margin, padding, ...rest }) => <Link {...rest} />;

StyledLink.propTypes = {
  margin: string,
  padding: string
};

const LinkButton = Button.withComponent(StyledLink).extend`
  &:hover,
  &:focus {
    color: ${colors.white};
    text-decoration: none;
  }
`;

export default LinkButton;



// WEBPACK FOOTER //
// ./src/components/common/LinkButton.js